import { FieldTemplate } from "db/definitions";

/**
 * Enforces all the properties are in the document before being sent to the UpdateTemplateForm component for editing.
 * @param {FieldTemplate} field document from the cloud
 * @returns a full field tempate.
 */
function enforceFieldTemplateDoc(field: FieldTemplate) {
	const fieldData: FieldTemplate = {
		id: field.id,
		formTemplate: field.formTemplate,
		inputType: field.inputType || "text",
		exportType: field.exportType || "text",
		exportActions: field.exportActions || [],
		header: field.header || "",
		tableField: field.tableField,
		action: field.action || [],
		actionData: field.actionData || [],
		rowOrder: field.rowOrder || [],
		deleted: field.deleted || false,
		tableFields: field.tableFields ? { items: [...field.tableFields.items] } : { items: [] },
		options: field.options,
		optionsOrder: field.optionsOrder ? [...field.optionsOrder] : [],
		exportData: field.exportData || [],
		continuationDataId: field.continuationDataId,
		docId: field.docId || "",
		group: field.group,
		readGroups: [...field.readGroups],
		pixelFollowing: field.pixelFollowing || 0,
		pixelInitial: field.pixelInitial || 0,
		rowsAllowed: field.rowsAllowed || 0,
		totalExtraLines: field.totalExtraLines || 0,
		font: field.font || "times new roman",
		fontSize: field.fontSize || 0.0,
		bold: field.bold || false,
		rollLinkId: field.rollLinkId || "",
		version: field.version,
		createdAt: field.createdAt,
		updatedAt: field.updatedAt,
		csvKey: field.csvKey || "",
		identityRole: field.identityRole || "",
	};

	if (field.baseFieldTemplate) {
		fieldData.baseFieldTemplate = field.baseFieldTemplate;
	}

	if (field.continuationDataId) {
		fieldData.continuationDataId = field.continuationDataId;
		fieldData.continuationData = field.continuationData;
		fieldData.pixelFollowing = field.pixelFollowing || 0;
		fieldData.pixelInitial = field.pixelInitial || 0;
		fieldData.rowsAllowed = field.rowsAllowed || 0;
		fieldData.totalExtraLines = field.totalExtraLines || 0;
		fieldData.font = field.font || "times new roman";
		fieldData.fontSize = field.fontSize || 0;
		fieldData.bold = field.bold || false;
	}

	return fieldData;
}

export default enforceFieldTemplateDoc;
